(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-parts-number"] && !window.DesignMode) return;
  try {
    
    class RelatedPartsNumber extends HTMLElement {
        constructor() {
            super();
            this.endCursor = null;
            this.hasNextPage = true;
            this.hasPreviousPage = false;
            this.productId = this.dataset.id || null;
            this.tag = this.dataset.tag || null;
            this.token = window.storefrontConfig.token
            this.loading = false;
            this.storefrontUrl = this.dataset.storefrontUrl || '/api/unstable/graphql.json';
            this.perPage = parseInt(this.dataset.perPage) || 6;
        }

        getSchema(cursor = null) {
            return `
                query getProducts($tag: String!, $first: Int!, $after: String) {
                    products(
                        first: $first
                        after: $after
                        query: $tag
                    ) {
                        edges {
                            cursor
                            node {
                                id
                                title
                                handle
                            }
                        }
                        pageInfo {
                            hasNextPage
                            hasPreviousPage
                            endCursor
                            startCursor
                        }
                    }
                }
            `;
        }

        async getRelatedItems(cursor = null) {
        if (!this.tag || this.loading) return;

        this.loading = true;
        this.showLoading();

        const variables = {
            tag: `tag:${this.tag}${this.productId ? ` AND NOT id:"${this.productId}"` : ''}`,
            first: this.perPage,
            after: cursor
        };

        try {
            const response = await fetch(this.storefrontUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.token
                },
                body: JSON.stringify({
                    query: this.getSchema(),
                    variables: variables
                })
            });

            const result = await response.json();
            
            if (result.errors) {
                console.error('GraphQL errors:', result.errors);
                this.showError('Failed to load related products');
                return;
            }

            const products = result.data.products;
            this.endCursor = products.pageInfo.endCursor;
            this.hasNextPage = products.pageInfo.hasNextPage;
            this.hasPreviousPage = products.pageInfo.hasPreviousPage;
        
            if (cursor) {
                this.appendProducts(products.edges);
            } else {
                this.renderProducts(products.edges);
            }

            this.updateLoadMoreButton();

        } catch (error) {
            console.error('Error fetching related products:', error);
            this.showError('Failed to load related products');
        } finally {
            this.loading = false;
            this.hideLoading();
        }
    }

    createProductHTML(product) {
        const title = product.title.split('|')[0].trim();
        
        return `
            <li class="related-parts-number__list-item" data-product-id="${product.id}">
                <a href="/products/${product.handle}" class="related-parts-number__list-item__link">
                    ${title}
                </a>
            </li>
        `;
    }

    renderProducts(products) {
        const container = this.querySelector('.related-parts-number__list') || this.createProductsList();
        
        if (products.length === 0) {
            container.innerHTML = '<li class="not-found"><p>No related parts numbers found</p></li>';
            return;
        }

        container.innerHTML = products.map(edge => this.createProductHTML(edge.node)).join('');
    }

    resetToInitial() {
        this.endCursor = null;
        this.hasNextPage = true;
        this.loading = false;
     
        this.getRelatedItems();
    }

    appendProducts(products) {
        const container = this.querySelector('.related-parts-number__list');
        if (!container) return; 

        const newProductsHTML = products.map(edge => this.createProductHTML(edge.node)).join('');
        container.insertAdjacentHTML('beforeend', newProductsHTML);
    }

    updateLoadMoreButton() {
        const loadMoreBtn = this.querySelector('.related-parts__load');
        const showLessBtn = this.querySelector('.related-parts__less'); 

         if (loadMoreBtn) {
            loadMoreBtn.style.display = this.hasNextPage ? 'block' : 'none';
            loadMoreBtn.addEventListener('click', () => this.loadMore());
        }

        if (showLessBtn) {
           showLessBtn.style.display = !this.hasNextPage && this.hasPreviousPage ? 'block' : 'none';
           showLessBtn.addEventListener('click', () => this.resetToInitial());
        }
    }

    loadMore() {
        if (this.hasNextPage && !this.loading) {
            this.getRelatedItems(this.endCursor);
        }
    }

    showLoading() {
        let loader = this.querySelector('.loading-indicator');
        if (loader) {
            loader.style.display = 'block';
            this.querySelector('.related-parts__load').style.display = 'none';
            this.querySelector('.related-parts__less').style.display = "none";
        }
    }

    hideLoading() {
        const loader = this.querySelector('.loading-indicator');
        if (loader) {
            loader.style.display = 'none';
        }
    }


    connectedCallback() {
        if (this.tag) {
            this.getRelatedItems();
        }
    }
    }

    if (customElements.get('related-parts-number') === undefined) {
        customElements.define("related-parts-number", RelatedPartsNumber);
    }

  } catch(e) { console.error(e); }
})();
})();
